// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"ec732354","334":"5ce7cd8e","340":"8bf289ac","621":"cc470740"}[chunkId] + ".chunk.js";
};